"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateIntegrationActivationEndpointSchema = exports.CreateIntegrationActivationSchema = exports.AuthTokensSchema = exports.AppAuthTokensSchema = exports.IntegrationAuthSchema = exports.AppIntegrationAuthSchema = exports.TokenIntegrationAuthSchema = exports.IntegrationId = exports.isAppAuthTokens = exports.AuthType = void 0;
const Joi = __importStar(require("joi"));
var AuthType;
(function (AuthType) {
    AuthType["Token"] = "TOKEN";
    AuthType["AppToken"] = "APP_TOKEN";
})(AuthType || (exports.AuthType = AuthType = {}));
const isAppAuthTokens = (tokens) => tokens.appToken != null;
exports.isAppAuthTokens = isAppAuthTokens;
var IntegrationId;
(function (IntegrationId) {
    IntegrationId["Economic"] = "cbc4c4af-b811-41ec-b340-179932c5ab2f";
})(IntegrationId || (exports.IntegrationId = IntegrationId = {}));
exports.TokenIntegrationAuthSchema = Joi.object({
    token: Joi.string().required(),
});
exports.AppIntegrationAuthSchema = Joi.object({
    appToken: Joi.string().required(),
    token: Joi.string().required(),
});
exports.IntegrationAuthSchema = Joi.alternatives(exports.TokenIntegrationAuthSchema, exports.AppIntegrationAuthSchema);
exports.AppAuthTokensSchema = Joi.object({
    appToken: Joi.string().required(),
});
exports.AuthTokensSchema = Joi.alternatives(exports.AppAuthTokensSchema, Joi.object({}));
exports.CreateIntegrationActivationSchema = Joi.object({
    integrationId: Joi.string().uuid().required(),
    creditorId: Joi.string().uuid().required(),
    tenantId: Joi.string().uuid().required(),
    options: Joi.object(),
    authentication: exports.IntegrationAuthSchema.required(),
    tokens: exports.AuthTokensSchema.required(),
});
exports.CreateIntegrationActivationEndpointSchema = Joi.object({
    creditorId: Joi.string().uuid().required(),
    authentication: exports.IntegrationAuthSchema.required(),
    options: Joi.object(),
});
//# sourceMappingURL=index.js.map